import { createContextManager, storeContextManager } from '@datadog/browser-core';
export function startUserContext(configuration) {
    const userContextManager = buildUserContextManager();
    if (configuration.storeContextsAcrossPages) {
        storeContextManager(configuration, userContextManager, 'rum', 1 /* CustomerDataType.User */);
    }
    return userContextManager;
}
export function buildUserContextManager() {
    return createContextManager('user', {
        propertiesConfig: {
            id: { type: 'string' },
            name: { type: 'string' },
            email: { type: 'string' },
        },
    });
}
//# sourceMappingURL=userContext.js.map